<template>
  <!--买卖合同（一般货物）-->
  <div class="business">
    <form>
      <h1 class="f-weight__500 text-center font-small title">买卖合同（一般货物）</h1>

      <div class="all-indent">
        <div class="cel">
          <div class="cel-content">买方（下称甲方）：</div>
          <div class="cel-content__full"> <input type="text" class="width-full" name="fpName" v-model="form.fpName" /> </div>
        </div>
        <div class="cel">
          <div class="cel-content">地址:</div>
          <div class="cel-content__full"> <input type="text" class="width-full" name="fpAddress" v-model="form.fpAddress"/> </div>
        </div>
        <div class="cel">
          <div class="cel-content">电话:</div>
          <div class="cel-content__full"> <input type="text" class="width-full" name="fpMobile" v-model="form.fpMobile"/> </div>
        </div>
        <div class="cel">
          <div class="cel-content">电子邮箱：</div>
          <div class="cel-content__full"> <input type="text" class="width-full" name="fpEmail" v-model="form.fpEmail"/> </div>
        </div>
        <div class="cel">
          <div class="cel-content">卖方（下称乙方）：</div>
          <div class="cel-content__full"> <input type="text" class="width-full" name="spName" v-model="form.spName"/> </div>
        </div>
        <div class="cel">
          <div class="cel-content">地址：</div>
          <div class="cel-content__full"> <input type="text" class="width-full" name="spAddress" v-model="form.spAddress"/> </div>
        </div>
        <div class="cel">
          <div class="cel-content">电话：</div>
          <div class="cel-content__full"> <input type="text" class="width-full" name="spMobile" v-model="form.spMobile"/> </div>
        </div>
        <div class="cel">
          <div class="cel-content">电子邮箱：</div>
          <div class="cel-content__full"> <input type="text" class="width-full" name="spEmail" v-model="form.spEmail"/> </div>
        </div>
      </div>
      <p>甲乙双方经充分协商，本着自愿及平等互利的原则，订立本合同。</p>

      <h5>第一条 名称、品种、规格和质量</h5>
      <p>1.名称、品种、规格：<input type="text" class="width-medium" name="guige" v-model="form.guige"/>（应注明产品的牌号或商标）。</p>
      <p>2.质量，按下列第（<input type="text" class="width-mini" name="djxzx" v-model="form.djxzx"/>）项执行：</p>
      <p>（1） 按照<input type="text" class="width-medium" name="andjxzx" v-model="form.andjxzx"/>标准执行（须注明按国家标准或部颁或企业具体标准，如标准代号、编号和标准名称等）。</p>
      <p>（2） 按样本，样本作为合同的附件（应注明样本封存及保管方式）。</p>
      <p>（3） 按双方商定要求执行，具体为：<input type="text" class="width-medium" name="sfyqzx" v-model="form.sfyqzx"/>（应具体约定产品质量要求）。</p>

      <h5>第二条 数量和计量单位、计量方法</h5>
      <p>1.数量：<input type="text" class="width-mini" name="shuliang" v-model="form.shuliang"/>。</p>
      <p>2.计量单位和方法：<input type="text" class="width-mini" name="jldwhff" v-model="form.jldwhff"/>。</p>
      <p>3.交货数量的正负尾差、合理磅差和在途自然增（减）量规定及计算方法：<input type="text" class="width-medium" name="jsff" v-model="form.jsff"/>。</p>
      <p>第三条 包装方式和包装品的处理：<input type="text" class="width-mini" name="bzfs" v-model="form.bzfs"/>（应尽可能注明所采用的包装标准是否国家或主管部门标准，自行约定包装标准应具体可行，包装材料由谁供应，包装费用的负担。）。</p>

      <p>第四条 交货方式：</p>
      <p>1.交货时间：<input type="text" class="width-medium" name="jhshijian" v-model="form.jhshijian"/>。</p>
      <p>2.交货地点：<input type="text" class="width-medium" name="jhaddress" v-model="form.jhaddress"/>。</p>
      <p>3.运输方式：<input type="text" class="width-medium" name="yunshufangshi" v-model="form.yunshufangshi"/>（注明由谁负责代办运输）。</p>
      <p>4.保 险：<input type="text" class="width-medium" name="insuranceName" v-model="form.insuranceName"/>（按情况约定由谁负责投保并具体规定投保金额和投保险种）。</p>
      <p>5.与买卖相关的单证的转移：<input type="text" class="width-medium" name="zhuanyi" v-model="form.zhuanyi"/>。</p>

      <p>第五条 验收：</p>
      <p>1.验收时间：<input type="text" class="width-medium" name="ysTime" v-model="form.ysTime"/>。</p>
      <p>2.验收方式：<input type="text" class="width-medium" name="ysMethod" v-model="form.ysMethod"/>（如采用抽样检验，应注明抽样标准或方法和比例）。</p>
      <p>3.验收如发生争议，由<input type="text" class="width-medium" name="jyjg" v-model="form.jyjg"/>检验机构按<input type="text" class="width-medium" name="jyfs" v-model="form.jyfs"/>检验标准和方法，对产品进行检验。</p>

      <p>第六条 价格与货款支付：</p>
      <p>1.单价：<input type="text" class="width-mini" name="perPrice" v-model="form.perPrice"/>；总价：<input type="text" class="width-medium" name="totalPrice" v-model="form.totalPrice"/>（明确币种及大写）。</p>
      <p>2.货款支付：</p>
      <p>货款的支付时间：<input type="text" class="width-medium" name="payTime" v-model="form.payTime"/>；</p>
      <p>货款的支付方式：<input type="text" class="width-medium" name="payMethod" v-model="form.payMethod"/>；</p>
      <p>运杂费和其它费用的支付时间及方式：<input type="text" class="width-medium" name="zfsjfs" v-model="form.zfsjfs"/>；</p>
      <p>3.预付货款：<input type="text" class="width-medium" name="yfhk" v-model="form.yfhk"/>（根据需要决定是否需要预付货款及金额、预付时间）。</p>

      <p>第七条 提出异议的时间和方法：</p>
      <p>
        1.甲方在验收中如发现货物的品种、型号、规格、花色和质量不合规定或约定，应在妥为保管货物的同时，自收到货物后
        <input type="text" class="width-medium" name="andjxzx" v-model="form.yyTime"/>
        日内向乙方提出书面异议；在托收承付期间，甲方有权拒付不符合合同规定部分的货款。甲方未及时提出异议或者自收到货物之日起
        <input type="text" class="width-mini" name="wtzTime" v-model="form.wtzTime"/>
        日内未通知乙方的，视为货物合乎规定。
      </p>
      <p>2.甲方因使用、保管、保养不善等造成产品质量下降的，不得提出异议。</p>
      <p>3.乙方在接到甲方书面异议后，应在<input type="text" class="width-medium" name="clyyTime" v-model="form.clyyTime"/>日内负责处理并通知甲方处理情况，否则，即视为默认甲方提出的异议和处理意见。</p>

      <p>第八条 甲方违约责任：</p>
      <p>1.甲方中途退货的，应向乙方赔偿退货部分货款的<input type="text" class="width-mini" name="wyj" v-model="form.wyj"/>％违约金。</p>
      <p>
        2.甲方未按合同约定的时间和要求提供有关技术资料、包装物的，除交货日期得以顺延外，应按顺延交货部分货款金额每日万分之
        <input type="text" class="width-mini" name="wjybl" v-model="form.wjybl"/>计算，向乙方支付违约金；如<input type="text" class="width-mini" name="wjyshijian" v-model="form.wjyshijian"/>
        日内仍不能提供的，按中途退货处理。
      </p>
      <p>
        3.甲方自提产品未按乙方通知的日期或合同约定日期提货的，应按逾期提货部分货款金额每日万分之
        <input type="text" class="width-mini" name="yqbl" v-model="form.yqbl"/>
        计算，向乙方支付逾期提货的违约金，并承担乙方实际支付的代为保管、保养的费用。
      </p>
      <p>4.甲方逾期付款的，应按逾期货款金额每日万分之<input type="text" class="width-mini" name="yqfkbl" v-model="form.yqfkbl"/>计算，向乙方支付逾期付款的违约金。</p>
      <p>5.甲方违反合同规定拒绝接受货物的，应承担因此给乙方造成的损失。</p>
      <p>6.甲方如错填到货的地点、接货人，或对乙方提出错误异议，应承担乙方因此所受到的实际损失。</p>
      <p>7.其它约定：<input type="text" class="width-medium" name="qtyueding" v-model="form.qtyueding"/>。</p>

      <p>第九条 乙方的违约责任：</p>
      <p>1.乙方不能交货的，向甲方偿付不能交货部分货款<input type="text" class="width-mini" name="yfwybl" v-model="form.yfwybl"/>％的违约金。</p>
      <p>2.乙方所交货物品种、型号、规格、花色、质量不符合同规定的，如甲方同意利用，应按质论价；甲方不能利用的，应根据具体情况，由乙方负责包换或包修，并承担修理、调换或退货而支付的实际费用。</p>
      <p>
        3.乙方因货物包装不符合合同规定，须返修或重新包装的，乙方负责返修或重新包装，并承担因此支出的费用。
        甲方不要求返修或重新包装而要求赔偿损失的，乙方应赔偿甲方该不合格包装物低于合格物的差价部分。因包装不当造成货物损坏或灭失的，由乙方负责赔偿。
      </p>
      <p>
        4.乙方逾期交货的，应按照逾期交货金额每日万分之
        <input type="text" class="width-mini" name="yfyqbl" v-model="form.yfyqbl"/>
        计算，向甲方支付逾期交货的违约金，并赔偿甲方因此所遭受的损失。如逾期超过
        <input type="text" class="width-mini" name="yfyqshijian" v-model="form.yfyqshijian"/>
        日，甲方有权终止合同并可就遭受的损失向乙方索赔。
      </p>
      <p>5.乙方提前交的货物、多交的货物，如其品种、型号、规格、花色、质量不符合约定，甲方在代保管期间实际支付的保管、保养等费用以及非因甲方保管不善而发生的损失，均应由乙方承担。</p>
      <p>6.货物错发到货地点或接货人的，乙方除应负责运到合同规定的到货地点或接货人外，还应承担甲方因此多支付的实际合理费用和逾期交货的违约金。</p>
      <p>
        7.乙方提前交货的，甲方接到货物后，仍可按合同约定的付款时间付款；
        合同约定自提的，甲方可拒绝提货。乙方逾期交货的，乙方应在发货前与甲方协商，甲方仍需要货物的，乙方应按数补交，并承担逾期交货责任；
        甲方不再需要货物的，应在接到乙方通知后<input type="text" class="width-mini" name="yftzshijian" v-model="form.yftzshijian"/>日内通知乙方，办理解除合同手续，逾期不答复的，视为同意乙方发货。
      </p>
      <p>8.其它：<input type="text" class="width-medium" name="otherWyzr" v-model="form.otherWyzr"/>。</p>

      <p>第十条 不可抗力：</p>
      <p>
        任何一方由于不可抗力原因不能履行合同时，应在不可抗力事件结束后<input type="text" class="width-mini" name="tbshijian" v-model="form.tbshijian"/>日内向对方通报，
        以减轻可能给对方造成的损失，在取得有关机构的不可抗力证明后，允许延期履行、部分履行或者不履行合同，并根据情况可部分或全部免予承担违约责任。
      </p>

      <p>第十一条 争议解决：</p>
      <p>凡因本合同引起的或与本合同有关的任何争议，如双方不能通过友好协商解决，均应提交中国国际经济贸易仲裁委员会深圳分会，按照申请仲裁时该会实行的仲裁规则进行仲裁。仲裁裁决是终局的，对双方均有约束力。</p>

      <p>第十二条 附加条款：</p>
      <p>1.<input type="text" class="width-medium" name="fjtkA" v-model="form.fjtkA"/>。</p>
      <p>2.<input type="text" class="width-medium" name="fjtkB" v-model="form.fjtkB"/>。</p>
      <p>3.<input type="text" class="width-medium" name="fjtkC" v-model="form.fjtkC"/>。</p>

      <p>第十三条 其它事项：</p>
      <p>1.按本合同规定应付的违约金、赔偿金、保管保养费和各种经济损失，应当在明确责任后<input type="text" class="width-mini" name="mqzrr" v-model="form.mqzrr"/>日内，按银行规定的结算办法付清，否则按逾期付款处理。</p>
      <p>
        2.约定的违约金，视为违约的损失赔偿。双方没有约定违约金或预先赔偿额的计算方法的，损失赔偿额应当相当于违约所造成的损失，包括合同履行后可获得的利益，
        但不得超过违反合同一方订立合同时应当预见到的因违反合同可能造成的损失。
      </p>
      <p>3.本合同自<input type="text" class="width-mini" name="shengxiaoshijian" v-model="form.shengxiaoshijian"/>日起生效，合同有效期内，除非经过对方同意，或者另有法定理由，任何一方不得变更或解除合同。</p>
      <p>4．合同如有未尽事宜，须经双方共同协商，作出补充规定，补充规定与本合同具有同等效力。</p>
      <p>
        5．双方来往函件，按照合同规定的地址或传真号码以<input type="text" class="width-medium" name="cdfs" v-model="form.cdfs"/>方式送达对方。如一方地址、电话、传真号码有变更，应在变更后的
        <input type="text" class="width-mini" name="bgshijian" v-model="form.bgshijian"/>日内书面通知对方，否则，应承担相应责任。
      </p>
      <p>6．本合同正本一式<input type="text" class="width-mini" name="contractNum" v-model="form.contractNum"/>份，双方各执<input type="text" class="width-mini" name="sfgzfs" v-model="form.sfgzfs"/>份；合同副本一式<input type="text" class="width-mini" name="htfbfs" v-model="form.htfbfs"/>份。</p>

      <ul class="sys-list-signer">
        <li>
          甲方（盖章）：<br />
          <input :value="new Date() | format('YYYY年MM月DD日')" type="text" class="width-full" />
        </li>
        <li>
          乙方（签字）：<br />
          <input :value="new Date() | format('YYYY年MM月DD日')" type="text" class="width-full"/>
        </li>
      </ul>
    </form>
  </div>
</template>

<script>
    export default {
        name: "business",
      data() {
        return {
          form: {
            fpName:'',
            fpAddress:'',
            fpMobile:'',
            fpEmail:'',
            spName:'',
            spAddress:'',
            spMobile:'',
            spEmail:'',
            guige:'',
            djxzx:'',
            andjxzx:'',
            sfyqzx:'',
            shuliang:'',
            jldwhff:'',
            jsff:'',
            bzfs:'',
            jhshijian:'',
            jhaddress:'',
            yunshufangshi:'',
            insuranceName:'',
            zhuanyi:'',
            ysTime:'',
            ysMethod:'',
            jyjg:'',
            jyfs:'',
            perPrice:'',
            totalPrice:'',
            payTime:'',
            payMethod:'',
            zfsjfs:'',
            yfhk:'',
            yyTime:'',
            wtzTime:'',
            clyyTime:'',
            wyj:'',
            wjybl:'',
            wjyshijian:'',
            yqbl:'',
            yqfkbl:'',
            qtyueding:'',
            yfwybl:'',
            yfyqbl:'',
            yfyqshijian:'',
            yftzshijian:'',
            otherWyzr:'',
            tbshijian:'',
            fjtkA:'',
            fjtkB:'',
            fjtkC:'',
            mqzrr:'',
            shengxiaoshijian:'',
            cdfs:'',
            bgshijian:'',
            contractNum:'',
            sfgzfs:'',
            htfbfs:''

          }
        }
      }
    }
</script>

<style lang="less" scoped>
  @import "../../assets/style/sysTpl";

  .business {
    font-family: "微软雅黑" !important;
    font-size: 16px;
    color: #666666;

    .title {
      margin: 40px 0;
    }
  }
</style>



// WEBPACK FOOTER //
// components/sys-contract/business.vue